import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PLATFORM_CHART_CARD } from '../lib/platform-dashboard-layout'

const { standard: card, donutCard } = PLATFORM_CHART_CARD

interface Props {
  title: string
  testId: string
}

export function PlatformChartComingSoonCard({ title, testId }: Props) {
  return (
    <Box
      data-testid={testId}
      sx={{
        border: card.border,
        borderRadius: card.borderRadius,
        bgcolor: card.bgcolor,
        height: donutCard.height,
        display: 'flex',
        flexDirection: 'column',
        pt: donutCard.paddingTop,
        px: donutCard.paddingX,
        pb: donutCard.paddingBottom,
      }}
    >
      <Typography
        sx={{
          fontSize: card.titleFontSize,
          fontWeight: card.titleFontWeight,
          fontFamily: card.titleFontFamily,
          color: card.titleColor,
          lineHeight: card.titleLineHeight,
          mb: donutCard.titleToBodyGap,
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: '16px',
            py: '8px',
            borderRadius: '100px',
            bgcolor: '#e3f2fd',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '16px',
              color: '#1976d2',
              whiteSpace: 'nowrap',
            }}
          >
            Coming Soon
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
